import React from "react";
import css from "./section.module.css";
import resources from "../../../../resources/index";
import Section5_2 from "./Section5_2";
import {FaAsymmetrik, FaBezierCurve, FaLayerGroup, FaTruck} from 'react-icons/fa'

const steps = [
  {
    num: "Step 1",
    title: "Research and Content Planing",
    desc: "Progressively foster enterprise-wide systems whereas equity invested web-readiness harness installed base bandwidth.",
  },
  {
    num: "Step 2",
    title: "Publishing and Execution",
    desc: "Progressively foster enterprise-wide systems whereas equity invested web-readiness harness installed base bandwidth.",
  },
  {
    num: "Step 3",
    title: "Product Prototyping",
    desc: "Interactively whiteboard transparent testing procedures before bricks-and-clicks initiatives administrate competencies.",
  },
  {
    num: "Step 4",
    title: "Deliver the Final Product",
    desc: "Dramatically plagiarize distributed progressive metrics without error-free globally simplify standardized alignments.",
  },
];
const Section5 = () => {
  return (
    <>
    <div className={css.section5}>

      <div className={css.section5_div1}>
        <h4>Process</h4>
        <h2>We Follow Our Work Process</h2>
        <p>
          Enthusiastically engage cross-media leadership skills for alternative
          experiences. Proactively drive vertical systems than intuitive
          architectures.
        </p>
      </div>

      <div className={css.section5_div2}>
        <div className={css.section5_img}>
          <img src={resources.images.home_sec5} alt="Home section5" />
        </div>
        <div className={css.section5_div2_steps}>
          <div className={css.steps_icons}>

            <span className={css.border_line}></span>

            <div className={css.icon_div}>
              <FaAsymmetrik className={css.icon} />
            </div>

            <div className={css.icon_div}>
              <FaBezierCurve className={css.icon} />
            </div>
            <div className={css.icon_div}>
              <FaLayerGroup className={css.icon} />
            </div>
            <div className={css.icon_div}>
              <FaTruck className={css.icon} />
            </div>
          </div>
          <div className={css.steps_info}>
            {steps.map((step, index) => {
              return (
                <div key={index}>
                  <h5>{step.num}</h5>
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
    </div>
    <Section5_2 />
  </>
  );
};

export default Section5;
